import axios from 'axios';
import { MasterDataTable } from '../DataTable/MasterDataTable';
import { useIntl } from 'react-intl';
import useUser from '../../hooks/User';
import React, { ReactNode, useState, useEffect, useMemo } from 'react'
import useAccessToken from '../../hooks/AccessToken';
import useSWR, { mutate } from 'swr';
import { TableColumn } from "react-data-table-component";
import { usePipelineStore } from '../../stores/PipelineStore';
import { useReceivableStore } from '../../stores/Receivable';
import Select from 'react-select';
import useModalEffect from '../../hooks/useModalEffect';
import { useCustomeStore } from '../../stores/CustomeStore';
import useDynamicTab from '../../hooks/useDynamicTab';
import DetailReportTermin from './DetailReportTermin';
import moment from 'moment-timezone';
import { DateRangePicker } from 'rsuite';
import useCalendarLocale from '../../hooks/CalendarLocale';
import usePredefinedRanges from '../../hooks/PredefinedRanges';
import useCheckIsMobile from '../../hooks/useCheckIsMobile';
import { startOfMonth, endOfMonth } from 'date-fns';
import { CustomField, SettingMultiPipelines } from '../../interfaces/Settings';
import { useSettingsStore } from '../../stores/SettingsStore';
import { ReportTerminFilter, ReportTerminType } from '../../interfaces/ReportTermin';
import { LeadTemplate } from '../../interfaces/AccountReceivable';
import { createReportTerminTableColumns } from './ReportTerminTableColumns';
import { useMerchantStore } from '../../stores/MerchantStore';
import { useMeetingStore } from '../../stores/MeetingsStore';
import { useProductStore } from '../../stores/ProductStore';
import { DataTableExport } from '../DataTable/DataTableExport';
import { TerminAttachmentModal } from './TerminAttachmentModal';
import { FilterReportTerminMain } from './FilterReportTermin/FilterReportTerminMain';
import useDragAndDropColumn from '../../hooks/useDragAndDropColumn';
import useDragAndDropTemplate from '../../hooks/useDragAndDropTemplate';
import { useDataTableStore } from '../../stores/DataTableStore';
import { getEndDate, getStartDate, getTypeDate } from '../../functions/pipeline';
import { useTemplateFilterReportTermin } from '../../stores/TemplateFilterReportTermin';

const API_URL = process.env.REACT_APP_API_URL

const ReportTermin = () => {
    const user = useUser();
    const token = useAccessToken();
    const intl = useIntl();
    const [openMenuId, setOpenMenuId] = useState<string | null>(null);
    const [isShowDetailReportTermin, setIsShowDetailReportTermin] = useState<boolean>(false);
    const [idDetailReceivable, setIdDetailReceivable] = useState<string>('');
    const { multiPipelines, selectMultiPipeline, setSelectMultiPipeline } = usePipelineStore()
    const { companyId } = useCustomeStore()
    const { selectTemplateIdPipeline, setSelectTemplateIdPipeline, setSelectMultiPipelineCustomField } = useReceivableStore();
    const [selectedTemplate, setSelectedTemplate] = useState<{ value: string, label: string } | null>(null);
    const [typeDate, setTypeDate] = useState('DUE');
    const calendarLocale = useCalendarLocale();
    const [startDate, setStartDate] = useState<Date>(startOfMonth(new Date()));
    const [endDate, setEndDate] = useState<Date>(endOfMonth(new Date()));
    const predefinedRanges = usePredefinedRanges();
    const { isMobile } = useCheckIsMobile()
    const [loading, setLoading] = useState<boolean>(true);
    const [isMounted, setIsMounted] = useState<boolean>(false);
    const [customFieldTermin, setCustomFieldTermin] = useState<CustomField>({})
    const { settings } = useSettingsStore()
    const { simplePipelines } = usePipelineStore();
    const { simpleMerchants } = useMerchantStore();
    const { simpleMeetings } = useMeetingStore();
    const { simpleProducts } = useProductStore();
    const [showAttachmentCustomFieldModal, setShowAttachmentCustomFieldModal] = useState<boolean>(false);
    const [terminData, setTerminData] = useState<ReportTerminType>({} as ReportTerminType);
    const [key, setKey] = useState<string>('');
    const [url, setUrl] = useState<string | string[]>('');
    const { updatedData: updatedDataColumn, setUpdatedData: setUpdatedDataColumn, handleDragEnd: handleDragEndColumn, sensors: sensorsColumn } = useDragAndDropColumn();
    const { updatedData: updatedDataCompany, setUpdatedData: setUpdatedDataCompany, handleDragEnd: handleDragEndCompany, sensors: sensorsCompany, hasChanges: hasChangesCompany, initializeData: initializeDataCompany, cancelChanges: cancelChangesCompany } = useDragAndDropTemplate();
    const { updatedData: updatedDataPersonal, setUpdatedData: setUpdatedDataPersonal, handleDragEnd: handleDragEndPersonal, sensors: sensorsPersonal, hasChanges: hasChangesPersonal, initializeData: initializeDataPersonal, cancelChanges: cancelChangesPersonal } = useDragAndDropTemplate();
    const { masterDateRange, setSelectedFilter, clearMasterDateRange } = useDataTableStore()
    const [selectAllColumn, setSelectAllColumn] = useState<boolean>(true);
    const [selectedDataValueCustomFieldTermin, setSelectedDataValueCustomFieldTermin] = useState<{ [key: string]: string | null | string[] | number }>({});
    const { userTemplateFilterReportTermin, companyTemplateFilterReportTermin, setUserTemplateFilterReportTermin, setCompanyTemplateFilterReportTermin } = useTemplateFilterReportTermin()

    useEffect(() => {
        if (settings.termins_custom_fields) {
            setCustomFieldTermin(JSON.parse(settings.termins_custom_fields))
        }
    }, [settings])

    const optionsTypeDate = [
        // { value: 'CREATE', label: intl.formatMessage({ id: "MASTERS.DATATABLE.TYPE.DATE_CREATED" }) },
        { value: 'DUE', label: intl.formatMessage({ id: "MASTERS.DATATABLE.TYPE.DATE_DUE_TERMIN" }) },
        { value: 'PAID', label: intl.formatMessage({ id: "MASTERS.DATATABLE.TYPE.DATE_PAID_TERMIN" }) },
    ]

    useEffect(() => {
        if (multiPipelines && multiPipelines.length > 0) {
            setSelectTemplateIdPipeline(multiPipelines[0].id);
            setSelectMultiPipelineCustomField(multiPipelines[0] as LeadTemplate);
        }
    }, [multiPipelines]);

    const fetcher = async (url: string) => {
        if (!selectTemplateIdPipeline) return null;

        try {
            const response = await axios.get(url, {
                headers: {
                    'X-Auth-token': token
                }
            })
            return response.data
        } catch (error) {
            console.log(error)
        }
    }

    const convertOldData = (oldData: any) => {
        const contentParsed = JSON.parse(oldData.content);
        const hide = contentParsed.column
            .filter((col: any) => col.omit) // Filter column yang di-omit
            .map((col: any) => {
                const matchedColumn = tableColumnsWithCustomFields.find((item) => item.name === col.name);
                return matchedColumn ? matchedColumn.id : null; // Mengambil id jika ditemukan
            })
            .filter((id: string | null): id is string => id !== null);
        const sort = tableColumnsWithCustomFields.map((col: any) => col.id);

        const newContent = {
            hide: hide,
            sort: sort,
            use: false,
            filter: contentParsed.filter
        };

        return {
            ...oldData,
            content: newContent
        };
    };

    const { data: leadTemplates = [] } = useSWR<LeadTemplate[]>(`${API_URL}lead-templates`, fetcher)
    const { data: userTemplate = [], error: userTemplateError, isLoading: userTemplateLoading } = useSWR(selectTemplateIdPipeline ? `${API_URL}user-view-templates/termin?leadTemplateId=${selectTemplateIdPipeline}` : null, fetcher)
    const { data: companyTemplate = [], error: companyTemplateError, isLoading: companyTemplateLoading } = useSWR(selectTemplateIdPipeline ? `${API_URL}company-view-templates/termin?leadTemplateId=${selectTemplateIdPipeline}` : null, fetcher)

    useEffect(() => {
        if (!userTemplateLoading && userTemplate && userTemplate?.data && userTemplate.data.length > 0) {
            let data = userTemplate.data.map((template: any) => {
                let parsedContent;

                try {
                    parsedContent = JSON.parse(template.content);
                } catch (e) {
                    return template;
                }

                if (parsedContent.column) {
                    return convertOldData(template);
                } else {
                    return {
                        ...template,
                        content: parsedContent
                    };
                }
            });

            setUserTemplateFilterReportTermin(data);
        }
    }, [userTemplate, userTemplateLoading]);

    useEffect(() => {
        if (!companyTemplateLoading && companyTemplate && companyTemplate?.data && companyTemplate.data.length > 0) {
            let data = companyTemplate.data.map((template: any) => {
                let parsedContent;

                try {
                    parsedContent = JSON.parse(template.content);
                } catch (e) {
                    return template;
                }

                if (parsedContent.column) {
                    return convertOldData(template);
                } else {
                    return {
                        ...template,
                        content: parsedContent
                    };
                }
            });
            setCompanyTemplateFilterReportTermin(data);
        }
    }, [companyTemplate, companyTemplateLoading]);

    useEffect(() => {
        if (leadTemplates && leadTemplates.length > 0) {
            setSelectTemplateIdPipeline(leadTemplates[0].id);
            setSelectMultiPipeline(leadTemplates[0] as SettingMultiPipelines)
        }
    }, [leadTemplates]);

const tableColumnsWithCustomFields =  createReportTerminTableColumns({
    intl,
    manageColumns: updatedDataColumn,
    customFieldTermin,
    simplePipelines,
    simpleMerchants,
    simpleMeetings,
    simpleProducts,
    settings,
    setShowAttachmentCustomFieldModal,
    setTerminData,
    setKey,
    setUrl,
    selectTemplateIdPipeline,
    selectMultiPipeline, // <== akan bereaksi ketika ini berubah
});
    const handleResetFilter = () => {
        if (masterDateRange.reportTermin?.startDate && masterDateRange.reportTermin?.endDate) {
            clearMasterDateRange()
        }
        setSelectedFilter('reportTermin', 'leadName', [])
        setSelectedFilter('reportTermin', 'merchantName', [])
        setSelectedFilter('reportTermin','tanggalPembayaran', [] )
        setSelectAllColumn(true)
        setUpdatedDataColumn(updatedDataColumn.map((data: TableColumn<ReportTerminType>) => ({ ...data, omit: false })));
        setUpdatedDataCompany(updatedDataCompany.map((data: ReportTerminFilter) => ({
            ...data,
            content: {
                ...data.content,
                use: false,
            }
        })))
        setUpdatedDataPersonal(updatedDataPersonal.map((data: ReportTerminFilter) => ({ ...data, content: { ...data.content, use: false } })))

    }

    let actions: ReactNode[] = []
    actions.push(<DataTableExport source={"report-termin"} columns={updatedDataColumn} customFieldTermin={customFieldTermin} />)
    actions.push(<FilterReportTerminMain
        optionTypeDate={optionsTypeDate}
        selectTemplateIdPipeline={selectTemplateIdPipeline}
        propsData={{
            updatedData: {
                manageColumns: updatedDataColumn,
                updatedDataCompany: updatedDataCompany,
                updatedDataPersonal: updatedDataPersonal
            },
            setUpdatedData: {
                setManageColumns: setUpdatedDataColumn,
                setUpdatedDataCompany: setUpdatedDataCompany,
                setUpdatedDataPersonal: setUpdatedDataPersonal
            },
            handleDragEnd: {
                handleDragEndColumn: handleDragEndColumn,
                handleDragEndCompany: handleDragEndCompany,
                handleDragEndPersonal: handleDragEndPersonal
            },
            cancelChanges: {
                cancelChangesCompany: cancelChangesCompany,
                cancelChangesPersonal: cancelChangesPersonal
            },
            sensors: {
                sensorsColumn: sensorsColumn,
                sensorsCompany: sensorsCompany,
                sensorsPersonal: sensorsPersonal
            },
            hasChanges: {
                hasChangesCompany: hasChangesCompany,
                hasChangesPersonal: hasChangesPersonal
            },
            initializeData: {
                initializeDataCompany: () => initializeDataCompany(updatedDataCompany),
                initializeDataPersonal: () => initializeDataPersonal(updatedDataPersonal)
            }
        }}
        handleResetFilter={handleResetFilter} selectAllColumn={selectAllColumn} setSelectAllColumn={setSelectAllColumn}
        setIsMounted={setIsMounted}
    />
    );

    useEffect(() => {
        setUpdatedDataColumn(tableColumnsWithCustomFields)
    }, [customFieldTermin, openMenuId,selectMultiPipeline])

    useEffect(() => {
        setUpdatedDataCompany(companyTemplateFilterReportTermin)
    }, [companyTemplateFilterReportTermin])

    useEffect(() => {
        setUpdatedDataPersonal(userTemplateFilterReportTermin)
    }, [userTemplateFilterReportTermin])

    useModalEffect({
        showModal: isShowDetailReportTermin,
        setShowModal: setIsShowDetailReportTermin,
        modalId: `detail-report-termin-${idDetailReceivable}`
    })

    const handleTemplateChange = (selectedOption: { value: string, label: string } | null) => {
        if (selectedOption) {
            setSelectedTemplate(selectedOption);
            const template = multiPipelines.find(t => t.id === selectedOption.value);
            if (template) {
                setSelectTemplateIdPipeline(template.id);
                setSelectMultiPipeline(leadTemplates.find(t => t.id === selectedOption.value) as SettingMultiPipelines)
                setSelectMultiPipelineCustomField(template as LeadTemplate);
                setIsMounted(true);
            }
        }
        handleResetFilter()
    };

    // Prepare options for Select
    const templateOptions = multiPipelines.map(template => ({
        value: template.id,
        label: template.name
    }));

    // Set initial selected template when multiPipelines loads
    useEffect(() => {
        if (multiPipelines && multiPipelines.length > 0 && !selectedTemplate) {
            const firstTemplate = {
                value: multiPipelines[0].id,
                label: multiPipelines[0].name
            };
            setSelectedTemplate(firstTemplate);
        }
    }, [multiPipelines, selectedTemplate]);

    useEffect(() => {
        if (isMounted) {
            if ((startDate && endDate && typeDate) || (masterDateRange.reportTermin?.startDate && masterDateRange.reportTermin?.endDate && typeDate)) {
                mutate(`${API_URL}receivable-reports/list`);
            }
            return;
        }
    }, [startDate, endDate, typeDate, selectTemplateIdPipeline, masterDateRange.reportTermin?.startDate, masterDateRange.reportTermin?.endDate]);

    useModalEffect({
        showModal: showAttachmentCustomFieldModal,
        setShowModal: setShowAttachmentCustomFieldModal,
        modalId: `attachments-termin-modal-${terminData?.id}`
    })

    useDynamicTab({ title: `${intl.formatMessage({ id: 'MENU.REPORT_TERMIN' })} | CRM WooBlazz` });

    return (
        <>
            <div className='row mb-5'>
                <div className='col-12 d-flex justify-content-between'>
                    <div style={{ minWidth: '200px' }}>
                        <Select
                            value={selectedTemplate}
                            onChange={handleTemplateChange}
                            options={templateOptions}
                            isSearchable={true}
                            placeholder="Pilih Template Pipeline..."
                            noOptionsMessage={() => "Tidak ada template ditemukan"}
                            styles={{
                                control: (provided) => ({
                                    ...provided,
                                    minHeight: '40px',
                                    fontSize: '14px',
                                }),
                                menu: (baseStyles) => ({
                                    ...baseStyles,
                                    zIndex: 1000,
                                }),
                                menuList: (baseStyles) => ({
                                    ...baseStyles,
                                    zIndex: 1000,
                                }),
                            }}
                        />
                    </div>
                    <div className="d-flex float-end px-3">
                        <Select
                            styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    border: "none", // Menghilangkan simbol garis
                                    backgroundColor: "none",
                                    maxWidth: "200px"
                                }),
                                option: (baseStyles, { isSelected, isFocused }) => ({
                                    ...baseStyles,
                                    backgroundColor: isSelected ? '#2684FF' : isFocused ? '#dcf2ff' : 'none',
                                    cursor: 'pointer'
                                }),
                            }}
                            theme={(theme) => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    primary: 'none',
                                },
                            })}
                            onChange={(data: any) => { setTypeDate(data.value) }}
                            value={optionsTypeDate.find(option => option.value === typeDate)}
                            className='react-select-styled z-index-3'
                            classNamePrefix='react-select'
                            options={optionsTypeDate}
                            placeholder='Select an option'
                            isSearchable={false}
                        />


                        <DateRangePicker
                            style={{ width: "250px" }}
                            cleanable={false}
                            character=" - "
                            format="dd MMM yyyy"
                            locale={calendarLocale}
                            value={[startDate, endDate]}
                            ranges={predefinedRanges}
                            placement="bottomEnd"
                            onChange={(value) => {
                                if (value && value.length === 2) {
                                    setStartDate(value[0]);
                                    setEndDate(value[1]);
                                    setIsMounted(true);
                                }
                            }}
                            showOneCalendar={isMobile}
                            disabled={loading}
                            isoWeek={true}
                            editable={false}
                        />

                    </div>
                </div>
            </div>
            <div className='row'>
                {
                    multiPipelines && multiPipelines.length > 0 && selectTemplateIdPipeline ? (
                        <MasterDataTable
                            tableKey="reportTermin"
                            tableColumns={updatedDataColumn}
                            actions={actions}
                            expanded
                            apiURL={`receivable-reports/list`}
                            setLoading={setLoading}
                            customParams={typeDate}
                            order='desc'
                            selectTemplateIdPipeline={selectTemplateIdPipeline}
                            dateStartFilter={masterDateRange.reportTermin?.startDate ? moment(masterDateRange.reportTermin?.startDate).format('YYYY-MM-DD') : undefined}
                            dateEndFilter={masterDateRange.reportTermin?.endDate ? moment(masterDateRange.reportTermin?.endDate).format('YYYY-MM-DD') : undefined}
                            dateStart={startDate ? moment(startDate).format('YYYY-MM-DD') : ''}
                            dateEnd={endDate ? moment(endDate).format('YYYY-MM-DD') : ''}
                            autoReload={false}

                        />
                    ) : (
                        <div className="alert alert-info">
                            No template available
                        </div>
                    )
                }
            </div>
            {
                isShowDetailReportTermin && (
                    <DetailReportTermin receivableId={idDetailReceivable} selectedDataValueCustomFieldTermin={selectedDataValueCustomFieldTermin} />
                )
            }
            {
                showAttachmentCustomFieldModal && (
                    <TerminAttachmentModal terminData={terminData} title={customFieldTermin[key].name} key={key} url={url} />
                )
            }
        </>
    )
}

export default ReportTermin